var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.972 7.922a1.405 1.405 0 0 1-.074-.275c-.054-.26-.113-.551-.245-.846-.737-1.683-1.954-2.878-3.618-3.552-.359-.148-.717-.192-1.031-.227l-.079-.01c-.363-.044-.903.006-1.409.522-2.145 2.16.67-.651-1.446 1.47L7.52 10.552l-.565.566-.132.132c-.064.064-.197.202-.58.59a.888.888 0 0 0 .01 1.255.883.883 0 0 0 1.252-.01c.388-.393.52-.53.584-.595l.118-.118.565-.566 5.551-5.554c2.116-2.12-.7.69 1.45-1.474l.006-.005h.014c.226.03.442.054.585.113 1.242.502 2.11 1.363 2.665 2.622.054.128.094.305.133.497l.03.143-.02.02a6660.058 6660.058 0 0 0-10.252 10.27c-.02.02-.02.02-.054.03l-4.055.855-.211.045.039-.182c.285-1.353.58-2.75.879-4.123a.882.882 0 1 0-1.723-.379c-.3 1.378-.594 2.78-.88 4.137l-.161.768c-.098.472.034.95.358 1.274.255.256.6.394.967.394.103 0 .207-.01.31-.035l.8-.167c1.33-.28 2.7-.57 4.05-.856.373-.079.682-.246.942-.512a6768.69 6768.69 0 0 1 10.247-10.27c.33-.33.511-.723.555-1.196a.889.889 0 0 0-.024-.3z",
    fill: "#2D6CE6",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0f84fb9bf7ecde2a16db462c223ce003.svg";
export { ForwardRef as ReactComponent };